//(function () {
//    'use strict';

//    angular.module("imApp").factory("dataImpsService", [function () {
//        let service = {};

//        return service;
//    }]);
//})();
